import type { FIXED_INDENTS } from 'vars/index'

import { styled } from '@linaria/react'
import { INDENTS } from 'vars/index'

export const PlayerPayPopupSmallSC = styled.div<{
  gap: FIXED_INDENTS
}>`
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: ${({ gap }) => `var(${gap})`};
  padding: var(${INDENTS.INDENT_50});
`

export const PlayerPayPopupSC = styled.div<{
  gap: FIXED_INDENTS
}>`
  position: absolute;
  top: 50vh;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: ${({ gap }) => `var(${gap})`};
  padding: var(${INDENTS.INDENT_50});
`

export const PlayerPayPopupTextSC = styled.div<{ gap: FIXED_INDENTS }>`
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  gap: ${({ gap }) => `var(${gap})`};
`

export const PlayerPayPopupButtonSC = styled.div`
  display: flex;
  height: 48px;
`
